<template>
  <div class="full-screen">
    <div class="main scroll-list" style="z-index: 1; height: calc(100% - 50px);">

      <div class="my-title">
        <div class="content">
          <img v-if="userInfo.vipType === 'none'" src="../../assets/images/user.png" id="userHeadImg" class="content-l">
          <img v-else src="../../assets/images/user-vip.png" id="userHeadImg" class="content-l">
          <div class="content-r">
            <p class="username">
              <span id="userAccount">{{ userInfo.account }}</span>
              <img v-if="userInfo.vipType === 'none'" src="../../assets/images/icon-vip2.png"/>
              <img v-else src="../../assets/images/icon-vip.png"/>
            </p>
            <p class="userid" id="userPassword">密码: {{ userInfo.password }} </p>
            <!-- <div class="ts"><span>请务必截图保存账户密码</span></div> -->
          </div>
          <div class="yj">永久域名：pgmh.top<span @click="copyUrl('http://pgmh.top')">复制</span></div>
          <div class="qd"><span  @click="showDailySignClick">签到领币</span></div>
          <div class="app-reward" v-if="userInfo.appRewardStatus !== 'off' && userInfo.appRewardStatus !== 'received'" @click="showAppDownloadReward"><span>下载奖励</span></div>
        </div>
      </div>

      <div class="bd-content">

        <div class="c-top">
          <div class="c-top-i">
            <p>
              <span class="f12">剩余金币</span>
              <span class="f14">{{ userInfo.avaliableAmount }}</span>
            </p>
          </div>
          <div class="c-top-i">
            <p v-if="userInfo.vipType === 'none'">
              <span class="f12">未开通VIP</span>
              <span class="f10"> --</span>
              <!-- <span class="btn">去开通</span> -->
            </p>
            <p v-else>
              <span class="f12">到期时间</span>
              <span class="f10">{{ userInfo.vipEndYear }}年{{ userInfo.vipEndMonth }}月{{ userInfo.vipEndDay }}日 {{ userInfo.vipEndHour}}时</span>
            </p>
          </div>
        </div>

        <div v-if="!isVip" class="billboards">
            <div class="bg"></div>
            <div class="f1">VIP会员</div>
            <div class="f2">开通后免费畅读千部漫画</div>
            <router-link to="/purchase" class="btn">立即开通</router-link>
          </div>

        <div :class="!isVip ? 'set-mobile' : 'set-mobile mt2' " v-if="!userInfo.mobile" >
          <div class="btn-box">
            <div class="bx">
              <button class="btn" type="button"  @click="toSetPhoneNumber">绑定手机 送40币</button>
              <button class="btn s2" type="button"  v-if="userInfo.appRewardStatus !== 'received'" @click="showAppDownloadReward">下载APP 送60币</button>
            </div>

          </div>
        </div>

        <div class="card-content">



          <ul class="card-list">

            <li class="list-item t1b">
              <a v-show="inAndroidBrowser" @click="downloadAndroidApp"><span class="c-red">下载APP</span></a>
              <a v-show="inIosBrowser" @click="showIosFixDesktopStep=true"><span class="c-red">添加到桌面</span></a>
            </li>

            <li class="list-item t1">
              <router-link to="/user/bind">
                <span>绑定手机</span>
                <span v-if="userInfo.mobile === '' || userInfo.mobile === null" class="t-r c-red">强烈建议绑定手机</span>
                <span v-else class="t-r c-red">{{ userInfo.mobile }}</span>
              </router-link>
            </li>

<!--            <li class="list-item t10">-->
<!--              <router-link to="/user/find-account">-->
<!--                <span>找回充值账号</span>-->
<!--              </router-link>-->
<!--            </li>-->

            <!-- <li class="list-item t6">
              <router-link :to="{path: '/shelf', query: {active: 'history'}}">
                <span>阅读记录</span>
              </router-link>
            </li> -->

            <li class="list-item t9">
              <router-link to="/user/password">
                <span>修改密码</span>
              </router-link>
            </li>

            <li class="list-item t2">
              <router-link to="/purchase">
                <span>充值中心 <span class=" bc">特惠</span></span>
              </router-link>
            </li>

            <li class="list-item t5">
              <a id="customer">
                <span>在线客服</span>
                <span class="t-r">（11:00 ~ 18:00）</span>
              </a>
            </li>

            <!-- <li class="list-item t7">
              <a id="tg" @click="openTg">
                <span>商务代理TG</span>
                <span class="t-r">@pgmhoffice</span>
              </a>
            </li> -->

            <!-- <li class="list-item t6">
              <a @click="openEmail()">
                <span>联系邮箱</span>
                <span class="t-r">{{ commInfo.customerServiceEmail }}</span>
              </a>
            </li> -->

          </ul>
        </div>
        <router-link to="/user/login" class="my-btn">切换账号</router-link>
      </div>

    </div>

    <bottom></bottom>

    <div v-show="showIosFixDesktopStep" class="add-icon">
      <div class="dialog-bottom row">
        <div class="dialog-down"></div>
        <span class="cc">请点击</span>
        <span class="cc"><img class="img" src="../../assets/img/icon-20.png"></span>
        <span class="cc">然后点击“添加到主屏幕”</span>
      </div>
      <div class="dialog-mask" @click="showIosFixDesktopStep=false"></div>
    </div>

    <!-- 弹窗 是否成功 -->
    <div id="payBackConfirm-modal" v-show="payBackConfirm" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>是否支付成功？</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="showPaySuccessAlert">是</button>
          <button class="btn btn2" type="button" @click="showPayFailAlert">否</button>
        </div>
      </div>
    </div>

    <!-- 弹窗 保存账号 -->
    <div id="paySuccess-modal" v-show="paySuccessAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts pay-s">
        <div class="find-success">
          <h3 class="icon-3">
            请记住永久域名
            <strong @click="copyUrl('http://pgmh.top')"  class="font-red-block">pgmh.top</strong>
          </h3>

          <p class="pw">
            <span>账号：<strong>{{ userInfo.account }}</strong></span>
            <span>密码：<strong>{{ userInfo.password }}</strong></span>
          </p>
          <p class="tc" v-if="userInfo.mobile===null">请<span>截图保存</span>或<span>绑定手机号</span>！</p>
          <p class="tc" v-else>您可以使用以上账号或直接使用手机号登录</p>

        </div>
        <div class="btnbox">
          <button class="btn" type="button" v-if="!userInfo.mobile"  @click="toSetPhoneNumber">绑定手机<span class="bi">送40币</span></button>
          <button class="btn btn2 button-am" type="button" v-if="inAndroidBrowser"  @click="downloadAndroidApp">下载最新APP<span class="bi">送60币</span></button>
        </div>
        <div class="btn-close"  @click="hidePaySuccessAlert"></div>
      </div>
    </div>


    <!-- 弹窗 解决办法 -->
    <div id="payFail-modal" v-show="payFailAlert" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts pay-s">
        <h3  class="icon-2">解决办法</h3>
        <div class="find-success">
          <p>1.请截图保存当前账号密码</p>
          <p class="pw">
            <span>账号：<strong>{{ userInfo.account }}</strong></span>
            <span>密码：<strong>{{ userInfo.password }}</strong></span>
          </p>

          <p v-show="inWebView || inAndroidBrowser" style="margin-top: 10px;">2.然后<span style="color: #c32900; margin: 0 3px;">下载最新App</span>进行支付</p>
          <p v-show="inIosBrowser">2.然后使用<span color="red">默认浏览器Safiri</span>进行支付</p>
        </div>
        <div class="btnbox">
          <button class="btn btn2" type="button" v-if="inAndroidBrowser"  @click="downloadAndroidApp">下载APP<span class="bi">送60币</span></button>
        </div>

        <div class="btn-close"  @click="hidePayFailAlert"></div>

      </div>
    </div>




    <div id="dailySign-modal" v-show="showDailySign"  class="fixed-confirm" style="display: block;">
      <div class="daily-sign">
        <div class="c">
          <div class="t">
            <div v-if="dailySignFinish" class="err-text">{{ dailySignTxt }}</div>
            <strong v-else>VIP可以领双倍金币</strong>
          </div>
          <div class="b">
            <ul>
              <li v-for="(item, index) in userDailySignConfig" :key="index"  :class="currentSignDay > index+1 ? 'end':''" :name="currentSignDay === index+1 && currentSignDay === selectSignDay ? 'active': ''">
                <span>第{{index+1}}天</span>
                <div class="dd">
                  <strong>+{{item}}金币</strong>
                  <strong class="vip">VIP+{{vipDailySignConfig[index]}}金币</strong>
                </div>
              </li>
            </ul>
            <div class="btnbox">
              <button class="btn" v-if="!dailySignFinish" type="button" @click="dailySignClick">签到</button>
              <button class="btn" v-else type="button" @click="showDailySign = false">关闭</button>
            </div>
            <div class="ccc"  @click="showDailySign = false">X</div>
          </div>
        </div>
      </div>
    </div>

    <div id="dailySignSuccess-modal" v-show="showDailySignSuccess" class="fixed-confirm" style="display: block;">
      <div class="dailySignSuccess">
        <div class="cc">
            <div class="s">+{{ receiveCount }}金币</div>
            <div class="p">VIP签到奖励翻倍</div>
            <div class="btnbox">
              <button class="btn" type="button" @click="showDailySignSuccess = false">确认</button>
            </div>
        </div>
      </div>
    </div>


    <!-- 下载奖励 -->
    <div id="app-reward-modal" v-show="appRewardModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c fixed-c-ts">
        <div class="find-success" >
          <h3 class="icon-3" v-if="userInfo.appRewardStatus === 'download'">
            <strong class="font-red-block" style="margin:.3rem;">下载领取60金币奖励</strong>
            <span class="tx">请先下载APP，再领取专属奖励!</span>
          </h3>
          <h3 class="icon-3" v-else-if="userInfo.appRewardStatus === 'wait_receive'">
            <strong class="font-red-block" style="margin:.3rem;">领取60金币奖励</strong>
          </h3>
          <h3 class="icon-3" v-else-if="userInfo.appRewardStatus === 'received'">
            <strong class="font-red-block" style="margin:.3rem;">{{ appRewardSuccessText }}</strong>
            <img src="../../assets/images/bi6.png" style="display: block; width: 110px; margin: 0 auto;" />
          </h3>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" v-if="userInfo.appRewardStatus !== 'received'" @click="appDownloadReward" style="color:#ac3815; font-weight: 600;">{{appRewardBtnText}}</button>
          <button class="btn btn2" type="button" v-if="userInfo.appRewardStatus === 'received'"  @click="appRewardModalClose"  style="background:#fff !important; color: #959388;border: 1px solid #e4ddd2;">关闭</button>
          <button class="btn btn2" type="button" v-else @click="appRewardModal = false" style="background:#fff !important; color: #959388;border: 1px solid #e4ddd2;">关闭</button>
        </div>
      </div>
    </div>


    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>

    <!-- <div class="fixed-qd" style="z-index: 10" @click="showDailySignClick"><span>签到</span></div> -->

    <div v-show="isMainLoading" class="home-main-loading"></div>

  </div>
</template>

<script>
import Bottom from '@/components/layer1/bottomIndex'
import Alert from '@/components/share/alert';
import userService from "../../services/userService";
import {getReportUrl, StaticApiBase} from "../../services/urlService";
import commService from "../../services/commService";
import payService from "../../services/payService";
import kkUtil from "../../assets/js/kk-util";
import {Kkconfig} from "../../assets/js/config";
import listService from "../../services/listService";
import getAxios from "../../services/axiosService";

export default {
  name: "user",
  data() {
    return {
      payBackConfirm: false,
      paySuccessAlert: false,
      payFailAlert: false,
      isLogin: true,
      isVip: false,
      userInfo: {},
      commInfo: {},
      downloadDesc: 'App下载',
      imUrl: '',
      showAlert: false,
      alertMsg: '',
      showIosFixDesktopStep: false,
      inWebView: false,
      inAndroidBrowser: false,
      inIosBrowser: false,
      isMainLoading: false,
      showDailySign: false,
      showDailySignSuccess: false,
      vipDailySignConfig: [], //vip签到
      userDailySignConfig: [], //普通用户签到
      currentSignDay: 0, //【登录才有】(当前该签第几天)，
      selectSignDay:0,
      receiveCount:0,
      dailySignFinish:false,
      dailySignTxt:'',
      appRewardModal:false,
      appRewardBtnText:'立即下载',
      appRewardSuccessText:'60金币领取成功!',
    }
  },
  methods: {
    openTg(){
      window.open('https://telegram.me/pgmhoffice',"_self");
    },
    showDailySignClick(){
      this.isMainLoading = true
      listService.getCategoryBooks('',1,1)
        .then(res => {
          this.isLoading = false;
          if (res.result) {
            this.showDailySign = true
            this.vipDailySignConfig = res.data.vipDailySignConfig.split(',')
            this.userDailySignConfig = res.data.userDailySignConfig.split(',')
            this.currentSignDay = res.data.currentSignDay
            this.selectSignDay = res.data.selectSignDay
            this.isMainLoading = false
          }
        })
    },
    showAppDownloadReward(){
      this.appRewardModal = true
    },
    appRewardModalClose(){
      this.appRewardModal = false
      this.getUserInfo()
    },
    appDownloadReward(){
      if(this.userInfo.appRewardStatus === 'wait_receive'){
        let axios = getAxios();
        axios.post('/api/user/receive_app_reward', {}, {
        })
        .then(res => {
          if(res.data.result){
            this.userInfo.appRewardStatus = 'received'
          }else(
            alert(res.data.msg)
          )
        })
      }else if(this.userInfo.appRewardStatus === 'download'){
        this.downloadAndroidApp()
      }
    },

    dailySignClick(){
      this.isMainLoading = true
      let axios = getAxios();
      axios.post('/api/user/daily_sign', {}, {
      })
      .then(res => {
        if(res.data.result){
          this.receiveCount = res.data.data.receiveCount
          this.currentSignDay += 1
          this.showDailySign = false
          this.showDailySignSuccess = true
          this.isMainLoading = false
        }else{
          this.dailySignFinish = true
          this.isMainLoading = false
          this.dailySignTxt = res.data.msg
        }

      })
    },
    getUserInfo() {
      userService.getUserInfo()
        .then(res => {
          if (res.result) {
            this.userInfo = res.data;
            if(this.userInfo.appRewardStatus === 'wait_receive'){
              this.appRewardBtnText = '领取奖励'
            }else{
              this.appRewardBtnText = '立即下载'
            }
          }
        })
    },
    getStaticApiUrl(path) {
      return `${StaticApiBase}${path}`;
    },
    toSetPhoneNumber(){
        this.$router.push('/user/bind')
      },
    register() {
      userService.register()
        .then(res => {
          if (res.result) {
            this.userInfo = res.data;
          }
          this.getUserInfo()
        })
    },
    // buildDownload() {
    //   let downloadBtn = document.getElementById("downloadBtn");
    //   this.clientType = kkUtil.getClientType();
    //   if (this.clientType == "ios") {
    //     this.downloadDesc = "添加桌面快捷";
    //     downloadBtn.onclick = function () {
    //       let container = document.getElementById("addScreenContainer");
    //       container.style.display = 'block';
    //     }
    //   } else {
    //     this.downloadDesc = "App下载";
    //     downloadBtn.href = this.commInfo.appDownloadUrl2;
    //   }
    // },
    // hideAddContainer() {
    //   let container = document.getElementById("addScreenContainer");
    //   container.style.display = 'none';
    // },
    openEmail() {
      userService.openEmail(this.commInfo.customerServiceEmail, 'home');
    },
    openQQ() {
      userService.openQQ(this.commInfo.customerServiceQQ, 'home');
    },
    downloadAndroidApp() {
      window.location.href = commService.getLocalInitData().appDownloadUrl2;
    },
    showPaySuccessAlert() {
      this.payBackConfirm = false;
      this.paySuccessAlert = true;
    },
    hidePaySuccessAlert() {
      this.paySuccessAlert = false;
    },
    showPayFailAlert() {
      this.payBackConfirm = false;
      this.payFailAlert = true;
    },
    hidePayFailAlert() {
      this.payFailAlert = false;
    },
    copyUrl(url){
      (function(){
        document.oncopy = function(e){
          e.clipboardData.setData('text',url)
          e.preventDefault();
          document.oncopy = null;
        }
      })(url);
      document.execCommand('Copy');
      this.alertMsg = '复制成功';
      this.showAlert = true;
    }
  },
  components: {
    bottom: Bottom,
    alert: Alert
  },
  mounted() {
    let $this = this;
    let currUser = userService.getLocalUserInfo();
    if (!currUser) {
      this.register();
    } else {
      this.getUserInfo();
    }
    this.$router.isBack = true;
    this.commInfo = commService.getLocalInitData();

    this.inWebView = kkUtil.isInWebView();
    this.inAndroidBrowser = kkUtil.isInAndroidBrowser();
    this.inIosBrowser = kkUtil.isInIosBrowser();

    // setTimeout(function () {
    //   $this.buildDownload();
    // }, 1000);
    //document.getElementById("reportUrlUser").href = getReportUrl(currUser.account);

  },
  watch: {
    userInfo: function () {
      this.$nextTick(function () {
        //document.getElementById("userHeadImg").src = this.getStaticApiUrl(this.userInfo.headImg);
        document.getElementById("userAccount").innerHTML = this.userInfo.account;
        document.getElementById("userPassword").innerHTML = "密码：" + this.userInfo.password;
        document.getElementById("customer").href = this.imUrl = Kkconfig.reqUrl.imUrl + "?account=" + this.userInfo.account;
        //支付返回后的弹框逻辑
        if (this.userInfo != null && payService.needAlertPayWarning()) {
          this.payBackConfirm = true;
        }
      });
    }
  }
}
</script>

<style scoped>
#pop-page {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/user.vue